export class Constants {
  public static SpecimenToBeDeleted = 'specimenToBeDeleted';
  public static AltI = 'alt+i';
  public static AddSpecimen = 'addSpecimen';
  public static IsSpecimenAdded = 'isSpecimenAdded';
  public static EnableToolbarOverMatDialog = 'enableToolbarOverMatDialog';
  public static ManagePackageSelectedBu = 'managePackageSelectedBu';
  public static ManagePackageSelectedAccounts = 'managePackageSelectedAccounts';
  public static SCHEDULE_DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  public static SCHEDULE_SLOT_LENGTHS = [10, 20, 30, 60];
  public static MIN_DATETIME_FORMAT = '1/1/0001 12:00:00 AM';
  public static MIN_DATETIME_UI_FORMAT = '0001-01-01T00:00:00';
  public static APP_TITLE = 'LabPort';
  public static MANAGE_USERS = 'Users';
  public static readonly MANAGE_CUSTOMER_USERS = 'Customer Users';
  public static readonly MANAGE_INTERNAL_USERS = 'Internal Users';
  public static readonly ANNOUNCEMENTS = 'Announcements';
  public static readonly REGISTER_LABEL = 'Label Registration';
  public static readonly ADD_LABEL = 'Add Label';
  public static readonly COMMERCIALORDER = 'Orders';
  public static readonly PURCHASEORDER = 'Purchase Orders';
  public static readonly MANAGEPACKAGES = 'Manage Packages';
  public static readonly ADD_INTERNAL_USER = 'Add Internal User';
  public static readonly ADD_CUSTOMER_USER = 'Add Customer User';
  public static readonly ADD_ANNOUNCEMENT = 'Create Announcement';
  public static readonly ADD_USER = 'Add User';
  public static readonly RESULTS = 'Test Results';
  public static PENDINGAPPROVALS = 'Pending Approvals';
  public static DASHBOARD = 'Dashboard';
  public static readonly TITLE_HOME = 'Home';
  public static ORDER = 'Order';
  public static readonly UPDATE_PASSWORD = 'Change Password';
  public static readonly EDIT_DETAILS = 'Edit your Details';
  public static readonly EMAIL_NOTIFICATIONS = 'Email Notifications';
  public static readonly SPECIMEN_TYPES = 'Specimen Types';
  public static readonly USER_ACTIVITY_LOGS = 'User Activity Log'
  public static EXTRA_SMALL_WIDTH_BREAKPOINT = 720;
  public static SMALL_WIDTH_BREAKPOINT = 959;
  public static MEDIUM_WIDTH_BREAKPOINT = 1414;
  public static OBSOLETE_BANNER_BREAKPOINT = 1450;
  public static readonly MEDIUM_WIDTH_BREAKPOINT_2 = 1080;
  public static IDLE_SESSION_TIME = '30';
  public static DATE_FORMAT = 'MM/dd/yyyy';
  public static APP_VERSION = 'version';
  public static TEST_CODES: string[] = ['FIRSTTRIMFS', 'FIRSTTRIFB', 'PE'];
  public static ORDER_STATUS: string[] = ['ReportPending', 'ReportUpdatePending', 'Awaiting_UorS', 'Finalized', 'Cancelled', 'Corrected'];
  public static GENDER_LIST: string[] = ['Female', 'Male', 'Ambiguous', 'Unknown'];
  public static RELATION_LIST: string[] = ['Self', 'Spouse', 'Child', 'Others'];
  public static readonly BUCODE_NTD = 'NTD';
  public static readonly BUCODE_DPT = 'DPT';
  public static readonly BUCODE_CTX = 'CTX';
  public static readonly BUCODE_TGI = 'TGI';
  public static readonly BUCODE_VCD = 'VCD';
  public static readonly BUCODE_TGI_VCD = ['TGI','VCD'];
  public static readonly PORTAL_NAME = 'LabPort';
  public static readonly QUESTIONS = 'Questions';
  public static readonly GENDER = 'Gender';
  public static UPLOAD_PATIENTS = 'Bulk Upload';
  public static readonly ERROR_PATIENT_INFORMATION = 'Error retrieving Patients information';
  public static NO_RECORDS_FOUND = 'No records found.';
  public static readonly PATIENT_LIST = 'Patient List';
  public static readonly GET_TESTS_LIST = 'Tests List';
  public static readonly CLEAR_TESTS_ACCOUNT_LIST = 'Clear tests account list';
  public static readonly CLEAR_TESTS_NAME_LIST = 'Clear tests name list';
  public static readonly ADD_PROJECT = 'Create New Project';
  public static readonly ADD_ACCOUNT = 'Create New Account';
  public static readonly ADD_PACKAGE = 'Create Package';
  public static readonly CREATE_NEW_SPECIMENTYPE = 'Create New Specimen Type';
  public static CLONE_PROJECT_EVENT = 'Clone_Project';
  public static readonly SPECIMEN_SHORT_NAME = 'Specimen Short Name';
  public static PRINT_HTML = 'printHTML';
  public static REPORT_INFO = 'ReportInfo';
  public static RESULT_AS_HTML = 'RESULT_AS_HTML';
  public static readonly ADD_ACCOUNT_FILTER = 'AddAccountFilter';
  public static ADD_RESULT_HEADER_ACCOUNT_FILTER = 'AddResultHeaderAccountFilter';
  public static readonly ADD_ACCOUNT_CHIP = 'AddAccountChip';
  public static ADD_ORDER_ACCOUNT_FILTER = 'AddOrderAccountFilter';
  public static ADD_ORDER_HEADER_ACCOUNT_FILTER = 'AddOrderHeaderAccountFilter';
  public static ADD_ORDER_ACCOUNT_CHIP = 'AddOrderAccountChip';
  public static ADD_COLLECTED_DATERANGE = 'AddCollectedDaterange';
  public static EXPORT_RESULT = 'ExportResult';
  public static EXPORT_ORDERS = 'ExportOrders';
  public static readonly EXPORT_PURCHASER_ORDERS = 'ExportPurchaserOrders';
  public static EXPORT_SPECIMENTYPE = 'exportSpecimenTypes';
  public static ENABLED_ACCOUNTS = 'EnabledAccountCodes';
  public static readonly GET_PATIENT_LIST = 'getPatientList';
  public static readonly PATIENT_DONOR_INFO_SECTION = 'Patient/Donor Information';
  public static BULK_UPLOAD_GET_PATIENT_LIST = 'GetBulkUploadPatientList';
  public static readonly ASSIGN_PATIENT = 'Assign Patients';
  public static GET_SPECIMENTYPE_LIST = 'GetSpecimenTypeList';
  public static readonly FETCH_SPECIMEN_LIST = 'FetchSpecimenList';
  public static readonly FETCHED_PATIENT_LIST = 'FetchedPatientList';
  public static FETCHED_TESTS_LIST = 'FetchedTestsList';
  public static ERROR_GETPATIENTS = 'ErrorOccuredWhileFetchingPatientList';
  public static ERROR_FETCHING_TESTS_LIST = 'ErrorOccuredWhileFetchingTestsList';
  public static PATIENT_CALL = 'PatientCall';
  public static BULK_UPLOAD_PATIENT_CALL = 'BulkUploadPatientCall';
  public static readonly PATIENT_CHANGED = 'PatientChanged';
  public static GENERATED_REPORT_UPDATE = 'GeneratedReportUpdate';
  public static USERNAME_AT_TOOLBAR = 'userNameAtToolbar';
  public static CLEAR_PATIENT_SEARCH = 'ClearPatientSearch';
  public static CLEAR_REQUISIION_SEARCH = 'CLearRequisitionSearch';
  public static CLEAR_SPECIMENTYPE_SEARCH = 'ClearSpecimenTypeSearch';
  public static CLEAR_PATIENT_LIST_SEARCH = 'ClearPatientListSearch';
  public static REQUISITION_CALL = 'RequisitionCall';
  public static SPECIMEN_CALL = 'SpecimenCall';
  public static EXPORT_SPECIMEN_TYPES = 'exportSpecimenTypes';
  public static GET_REQUISITION_LIST = 'getRequisitionList';
  public static FETCHED_REQUISITION_LIST = 'fetchedRequisitionList';
  public static ERROR_REQUISITIONS = 'errorRequisitions';
  public static QUESTIONS_CALL = 'QuestionsCall';
  public static GET_SPECIMEN_DETAIL = 'getSpecimenDetail';
  public static ASSIGN_PATIENTS_CHECKBOX = 'assignPatientsCheckbox';
  public static ASSIGN_PATIENTS_SELECTALL = 'assignPatientsSelectAll';
  public static PAGINATION_RESET = 'paginationReset';
  public static BULK_UPLOAD_PATIENT_INFO = 'bulkUploadPatientInfo';
  public static PATIENT_LIST_CALL = 'PatientListCall';
  public static CREATE_NEW_QUESTION = 'Create New Question';
  public static CLAIMS = 'claims';
  public static DIALOG_FLAG = 'dialogFlag';
  public static AUTH_INFO = 'auth_info';
  public static TRY_AGAIN = 'Try again';
  public static SEND_OTP = 'sendOtp';
  public static DELIVERY_METHOD_SMS ='sms';
  public static DELIVERY_METHOD_EMAIL='email';
  public static SIGNALR_NOTIFICATION = 'SignalRNotificationHub';
  public static DASHBOARD_WIDGET_NOTIFICATION = 'dashboardWidgetNotification';
  public static SIGNALR_GET_CONNECTION_ID = 'GetConnectionId';
  public static SUCCESS_NOTIFICATION = 'Success';
  public static INFO_NOTIFICATION = 'Info';
  public static WARNING_NOTIFICATION = 'Warning';
  public static REFRESH_ORDER_LIST = 'refreshOrderList';
  public static PURCHASE_TEST = 'purchaseTest';
  public static PURCHASE_TEST_FOR_PATIENT = 'purchaseTestForPatient';
  public static REFRESH_ORDERS = 'refreshOrders';
  public static REFRESH_ORDER_RESULTS_LIST = 'refreshOrdersResults';
  public static ACCOUNT_LIST = 'Account List';
  public static PACKAGE_LIST = 'Manage Packages';
  public static PACKAGE_CREATED_SUCCESS = 'Upload completed successfully';
  public static PACKAGE_CREATED_FAILURES = 'Upload completed with failures';
  public static RESULT_SELECTED_ACCOUNT = 'resultSelectedAccount';
  public static ORDER_SELECTED_ACCOUNT = 'orderSelectedAccount';
  public static IS_ALL_ORDER_ACCOUNTS ='isAllOrderAccounts';
  public static ACCOUNTCODE_FOR_SELECTEDBU = 'accountCodeForSelectedBU';
  public static readonly IS_ALL_RESULT_ACCOUNTS ='isAllResultAccount';
  public static CU_EVENT_ACCESSIONID = 'CUEventAccessionId';
  public static CUSTOM_USER_EVENT = 'CustomUserEvent';
  public static IDMBASICAUTHTOKEN = 'idmBasicAuthToken';
  public static ORDER_TRACKER = 'Order Status Tracker';
  public static PACKAGE_FAILURE = 'Package Creation Failed';
  public static DATA_SAVED = 'Project Updated Successfully';
  public static REQUISITION_MANIFEST = 'Requisition Manifest';
  public static PACKAGEMANIFEST_VALUE = 'packageManifestValue';
  public static SPECIMENTEMPLATE_NOTFOUND = ', but sorry! label could not be generated due to invalid Request Type Category.';
  public static SPECIMENTEMPLATE_NOTFETCHED = ', but sorry! label could not be generated due to technical issue.';
  public static readonly CREATE_LABEL_FAILURE = 'Label Creation Failed';
  public static readonly EDIT_LABEL_FAILURE = 'Edit Label Range Failed';
  public static readonly GET_LABEL_FAILURE = 'Error retrieving Labels';
  public static readonly DELETE_LABEL_FAILURE = 'Error deleteing Labels range';
  public static readonly CREATE_LABEL_SUCCESS = 'Label Created Successfully';
  public static readonly EDIT_LABEL_SUCCESS = ' Edited Label Range Successfully';
  public static RANGE_DELETE_SUCCESS = 'Range Deleted Successfully';
  public static RANGE_EXISTS = 'RangeAlreadyRegistered';
  public static REQUISITION_USED_FOR_ORDER = 'RequisitionUsedForOrder';
  public static BULK_ORDERS_PAGE = 'Bulk Orders';
  public static CLOSE_MAT_AUTOCOMPLETE = 'CLOSE_MAT_AUTOCOMPLETE';
  public static FILE_PROCESS_SUCCESS = 'Your file is being processed.';
  public static FILE_PROCESS_FAIL = 'Error occurred while validating the file.';
  public static PREFERRED_COMMUNICATION_LIST: string[] = ['Email', 'Text', 'Phone'];
  public static MAX_FILESIZE_25MB = 26214400;
  public static PREFERRED_COMMUNICATION_EMAIL = 'Email';
  public static STUDY_PATIENT_OPTION_YES = 'Yes';
  public static STUDY_PATIENT_OPTION_NO = 'No';
  public static MANUAL_PAYORID = 'UNK';
  public static readonly DIFFERENT_CLIENTID1_ERROR = 'ClientId1 is not same as other requisitions of this Package.';
  public static readonly INVALID_SAMPLE_SOURCE ='Invalid sample sources found in the specimen table:';
  public static EDIT_DEMO_GRAPIC_VALUE_MAPPING = {
    Date: 'valueDate',
    Float: 'valueNumeric',
    Integer: 'valueNumeric',
    String: 'valueText',
    Enum: 'valueEnumerationCode'
  };
  public static ORDERS_PARAMETER = {
    Date: 'ValueDate',
    Float: 'ValueNumeric',
    Integer: 'ValueNumeric',
    String: 'ValueText',
    Enum: 'ValueEnumerationCode'
  };
  public static readonly INTERNAL_USER = 'internal';
  public static readonly EXTERNAL_USER = 'external';
  public static readonly HOME_TAB = '/home';
  public static readonly RESULTS_TAB = '/results';
  public static readonly CREATE_CUSTOMER_USER = 'create-customer-user';
  public static readonly EDIT_CUSTOMER_USER = 'edit-customer-user';
  public static MANAGE_USER_TAB = 'subTabManageUser';
  public static RESULTS_TOOL_BAR_TAB = 'subTabResult';
  public static GET_TEST = 'getTestDetails';
  public static GET_LINKEDACCOUNTS_BY_BUCODE = 'getLinkedAccountsByBUCode';
  public static GET_BU_SELECTION_IN_DIALOG = 'getBUSelectionInDialog';
  public static GET_LA_SELECTION_IN_DIALOG = 'getLASelectionInDialog';
  public static GET_LA_SELECTION_CHIP_IN_DIALOG = 'getLASelectionChipInDialog';
  public static FETCHED_LINKED_ACCOUNT = 'FetchedLinkedAccount';
  public static LOGGED_IN_USER_INFO = 'loggedInUserInfo';
  public static IS_VERIFICATION_SUCCESSFUL = 'isVerificationSuccessful';
  public static readonly VERIFICATION_SUCCESSFUL = "Verification successful!";
  public static readonly VERIFICATION_FAILED = "Verification failed.";
  public static readonly VERIFICATION_CODE_REQUIRED = 'Verification code you have entered is expired. Please generate a new code and try.'; 
  public static readonly VERIFICATION_CODE_NOT_MATCHING = 'Verification code you have entered is wrong. Please enter a valid verification code.';
  public static readonly VERIFICATION_CODE_INVALID_OR_EXPIRED = "The verification code provided is invalid or expired.";
  public static readonly VERIFICATION_REFRESHTOKEN_FAILED = "Refresh Token failed. Please Re-Login.";
  public static readonly VERIFICATION_TOO_MANY_REQUESTS = 'TooManyRequests';
  public static readonly ACCOUNT_LOCKED_MESSAGE = `Too many failed attempts detected. To protect your account, access is temporarily restricted.`;
  public static PLEASE_RELOGIN =" Please Re-Login.";
  public static AUTHORIZED_CONTROLS = 'authorized_controls';
  public static ACCOUNT_CODES_WITH_PRINTED_LABELS_PREF = 'AccountCodeswithPrintedLabelsPref';
  public static FILTER_EVENT = 'FILTER_EVENT';
  public static NPI_FILTER_EVENT = 'NPI_FILTER_EVENT';
  public static PATIENTS_LOADED = 'PATIENTS_LOADED';
  public static EXPORT_EVENT = 'EXPORT_EVENT';
  public static ACK_DIALOG_EVENT = 'ACK_DIALOG_EVENT';
  public static CSV_FORMAT = 1;
  public static XLSX_FORMAT = 2;
  public static XLS_FORMAT = 3;
  public static RESULT_FILE_NAME = 'Export_';
  public static RESULT_WORKSHEET_NAME = 'ResultList_';
  public static COMMERCIALORDERS_FILE_NAME = 'Orders_';
  public static SPECIMENTYPE_FILE_NAME = 'Export_';
  public static SPECIMENTYPE_WORKSHEET_NAME = 'Specimen_';
  public static ENTER_DETAILS_MANUALLY = 'Enter Details Manually';
  public static SEARCH_BY_NPI = 'Search By Name or NPI';
  public static EMAIL_STANDARD_REGEX =
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,100})$/i;
  public static readonly EMAIL_DOMAIN_REGEX = /^[^\s@]+@(?:[^\s@]*eurofins[^\s@]*|empowerdxlab|radiantdelivers|clinicalenterprise)\.\w{2,100}$/i;
  public static NPI_NUMBER_REGEX = /^((2)([0-9]{9})|(1)([0-9]{9}))$/i;
  public static readonly PRACTICE_ID_REGEX = /^123(\d{7})P$/;
  public static SYMBOL_REGEX_1 = /([!@#$%^&*\.\-_+=[\]{}|\\:',?/`~"();])+/g;
  public static SYMBOL_REGEX_2 = /(^([0-9A-Za-z\d@#$%^&*\.\-_+=[\]{}|\\:',?/`~"();!])+$)/g;
  public static SYMBOL_REGEX_3 = '! @ # $ % ^ &amp; * - _ + = [ ] { } |  : ‘ , . ? / ` ~ “ ( );';
  public static SYMBOL_REGEX_4 = /(^([0-9A-Za-z\d@#$%^&*\.\-_+=[\]{}|\\:',?/`~"();!])+$)/;
  public static FAX_NUMBER_FORMAT = /(^([0-9]{1}[0-9]{9})$)/g;
  public static ZIP_FORMAT = /(^\d{5}$)/g;
  public static PHONE_FORMAT = /(^$)|(^\d{10}$)/g;
  public static KITID_FORMAT = /^EDX-\d{4}-\d{3}$/g;
  public static TRACKING_ID_REGEX = /^[^;]+$/;
  public static REQUISITION_REGEX = /^[rR]-[pP]\d{8}$/;
  public static IsEdit = 'isEdit';
  public static PRIVACY_POLICY = 'Privacy Policy';
  public static TERMS_OF_USE = 'Terms of Use';
  public static NO_CONTENT_INFO = 'Could not load info';
  public static NO_COMPUTATION_FORMULAS = 'No computation formulas found';
  public static PAGINATION_PAGE_SIZE = 25;
  public static PAGINATION_PAGE_SIZE_OPTIONS = [
    25,
    50,
    100
  ];
  public static STATUS_FINALIZED = 'Finalized';
  public static STATUS_CANCELLED = 'cancelled';
  public static USER_ACTIVE = 'Active';
  public static TESTINGREASONFORCAUSE = 'For cause'

  public static CAN_VIEW_PATIENT_RESULT_FOR_LA = 'CanViewPatientResultForLA';
  public static CAN_MANAGE_CUSTOMER_USERS = 'CanManageCustomerUsers';

  public static DISPLAY_ONCE_UPON_LOGON = 'DisplayOnceUponLogon';
  public static DISPLAY_UPON_EACH_USER_LOGIN = 'DisplayUponEachUserLogon';
  public static GENETIC_COUNSELOR = 'Genetic counselor';
  public static COPY_TO_PROVIDER = 'Copy-to-provider';
  public static REFERRING_PHYSICIAN = 'Referring physician';
  public static OPTIONAL_INSURANCE_STEPPER = 'OptionalInsuranceStepper';
  public static PATIENT_SHEET_NAME = 'Patients_';
  public static PATIENT_FILENAME = 'Patients_';
  public static ACKNOWLEDGEMENT_SAVE_ERROR = 'AcknowledgementError';
  public static SUBTAB_MANAGE_LABCONFIG = 'subTabManageLabConfiguration';
  public static QUESTIONS_SHEET_NAME = 'Questions_';
  public static QUESTIONS_FILENAME = 'Questions_';
  public static TESTS_FILENAME = 'Tests_';
  public static TESTS_SHEET_NAME = 'Tests_';
  public static EXPORT_QUESTIONS = 'ExportQuestions';
  public static EXPORT_PATIENTLIST = 'ExportPatientList';
  public static TESTS_PAGE = 'Tests/Panels';
  public static TESTS_CALL = 'testsCall';
  public static EXPORT_TESTS = 'exportTests';
  public static SUB_TAB_ORDER = 'subTabOrders';
  public static MANAGE_PROJECTS = 'Projects';
  public static PROJECTS_CALL = 'projectsCall';
  public static CLEAR_PROJECT_SEARCH = 'clearProjectsSearch';
  public static GET_PROJECTS_LIST = 'getProjectsList';
  public static FETCHED_PROJECTS_LIST = 'fetchedProjectsList';
  public static ERROR_PROJECTS = 'errorProjects';
  public static CLEAR_QUESTION_SEARCH = 'getQuestionNames';
  public static GET_QUESTION_LIST = 'getQuestionList';
  public static FETCH_QUESTION_LIST = 'fetchQuestionList';
  public static ERROR_QUESTIONS = 'errorQuestions';
  public static RELATIVE_ROUTE = './';

  public static FIELD_TYPE_CHECKBOX = 'CheckBox';

  public static PROJECT_SELECTED = 'ProjectSelected';
  public static PATIENT_GUID = 'patientGuid';
  public static readonly PATIENT_DOB = 'patientDob';
  public static readonly PATIENT_LASTNAME = 'patientLastName';
  public static readonly PATIENT_FIRSTNAME = 'patientFirstName';
  public static readonly PATIENTID = 'patientId';
  public static PATIENT_EMAIL_ID = 'patientEmailId';
  public static PATIENT_RELATION = 'patientRelation';
  public static PATIENT_STATUS = 'patientStatus';
  public static PATIENT_LA = 'patientLA';
  public static LOCAL_STATE_LIST = 'localStateList';
  public static LOCAL_RACE_LIST = 'local_race_list';
  public static LOCAL_ETHNICITY_LIST = 'local_ethnicity_list';
  public static DIAGNOSTIC_CODES = 'DiagnosticCodes';
  public static QUESTION_NOT_FOUND = 'LabPort Question Code does not exist';
  public static ACCOUNTS_NOT_FOUND = 'Linked Account does not exist';
  public static TIMEPICKER_TYPE = 'TimePicker';
  public static REPORT_DOWNLOAD_CONFIG_ERROR = 'Error fetching business unit details for report download config';
  public static FETCH_SHIPPER_TYPE_ERROR = 'Error retrieving Shipper Types.';
  public static FETCH_ACCOUNT_DATA_ERROR = 'Error retrieving Account Data.';
  public static SIDENAV_WIDTH = 'sideNavWidth';
  public static MAX_DATE = 'maxDate';
  public static MIN_DATE = 'minDate';
  public static CURRENT_DATE = 'currentDate';
  public static ORDER_FORM_REQUEST = 'orderFormRequest';
  public static PACKAGE_FORM_FEILDS = 'packageFormFields';
  public static PACKAGE_MANIFEST_REQUEST = 'packageManifestRequest';
  public static SPECIMEN_INFO = 'Specimen Information';
  public static PARAMETER_TRUE = 'true';
  public static PARAMETER_FALSE = 'false';
  public static PACKAGEGRID_FAILURE_MESSAGE = 'Failed to fetch Packages';
  public static PACKAGE_MANIFEST_FAILURE_MESSAGE = 'Error retrieving package Manifest Details.';
  public static ASCENDING_ORDER = 'asc';
  public static IS_REQUIRED = 'required';
  public static SENDPACKAGE_SUCCESS_MESSAGE = 'Package sent successfully.';
  public static SENDPACKAGE_FAILURE_MESSAGE = 'Sending Package Failed.';
  public static REQUISITION_MANIFEST_DATA = 'requisitionManifestData';
  public static ORDER_CANCELLATION_FAILED = 'Order Cancellation failed.';
  public static ORDER_CREATION_SUCCESS = 'Order Created Successfully.';
  public static readonly ORDER_SENT_TO_LAB_SUCCESS = 'Order Sent to Lab Successfully.';
  public static readonly FORM_VALIDATED_SUCCESS = 'Form validated successfully';
  public static readonly STANDING_ORDER_EXPIRED_MESSAGE = 'This order can no longer be sent to the lab because it is expired.';
  public static ORDER_CANCELLATION_SUCCESS = 'Order Cancelled Successfully';
  public static PACKAGE_CANCELLATION_SUCCESS = 'Package Cancelled Successfully';
  public static PACKAGE_CANCELLATION_FAILED = 'Package Cancellation failed.';
  public static ORDERTRCKER_FAILURE_MESSAGE = 'Failed to fetch Order Status Tracker';
  public static INACTIVE_ACCOUNT_MESSAGE = 'The account of the requisition is Inactive/Deleted.';
  public static ANNOUNCEMENT_DATA_FOR_BANNERS =  'AnnouncementDataForBanners';
  public static ISANNOUNCEMENTSHOWN = 'isAnnoucementShown';
  public static LOCALE_ID = 'en-US';
  public static readonly DATE_FORMAT_MMDDYYYY = 'MM/dd/yyyy';
  public static readonly DATETIME_FORMAT_MMDDYYYY_HHMMA = 'MM/dd/yyyy, hh:mm a';
  public static REQUISITION_IN_RANGE = 'RequisitionExistsInRange'
  public static REQUISITION_USED = 'RequisitionUsed';
  public static INVALID_REQUISITION_FORMAT='InvalidRequisitionFormat';
  public static RANGE_DOESNOT_EXIST = 'Requisition RangeDoesNotExists';
  public static REQUISTION_DOESNOT_EXIST_IN_RANGE = 'RequistionDoesNotExistsInRange';
  public static BULK_UPLOAD_ORDER_REQUEST = 'BulkUploadOrderRequest';
  public static SPECIMEN_EDITED = 'specimenEdited';
  public static ORDER_ACCOUNT = 'OrderAccount';
  public static DONOR_TEMPLATE = 'DONOR';
  public static TEST_TEMPLATE = 'TEST';
  public static LINKED_ACCOUNT = 'LinkedAccounts';
  public static LINKED_WITH_AUTH_ACCOUNT = 'LinkedAccountsWithAuthAccounts';
 public static USER_PREFERENCE = 'UserPreferences';
 public static SUCCESS = "SUCCESS";
 public static CONCURRENT_PACKAGE_UPDATE = "Concurrent Package Update Error";
 public static ORDER_MANIFEST = "OrderManifest";
 public static PACKAGE = "Package";
 public static ERROR_MESSAGE_FOR_FILTER = "Oops! You are not authorized to access users with the BU you are trying.";
 public static readonly ERROR_MESSAGE_UNAUTHORIZED_FOR_REQUISITION = "Oops! You are not authorized to access the requisition #";
 public static readonly PAYORS = "Payors";
 public static readonly CREATE_NEW_PAYOR = 'Create New Payor';
 public static readonly PATIENT_DOB_MIN_DATE_IN_MS = new Date(1901,0,1).getTime();
 public static readonly PATIENT_DOB_MIN_DATE = new Date(1901,0,1);

 public static readonly SAMPLE_SOURCE_REFRESH = 'sampleSourceRefresh';
 public static readonly SAMPLE_SOURCE_READY = 'sampleSourceReady';
 public static readonly INCLUDE_ARCHIVED_ORDERS = 'INCLUDE_ARCHIVED_ORDERS';
 public static readonly DRAW_IN_NEXT_N_DAYS = 'DRAW_IN_NEXT_N_DAYS';
 public static readonly SO_EXPIRING_IN_NEXT_N_DAYS = 'SO_EXPIRING_IN_NEXT_N_DAYS';
 public static readonly IS_STANDING_ORDERS_ONLY = 'IS_STANDING_ORDERS_ONLY';
 public static readonly ORDER_STATE_RULE_OPERATOR_IN = 'IN';
 public static readonly ORDER_STATE_RULE_OPERATOR_NOT_IN = 'NOT IN';
 public static readonly NPL_REQUIRED_MESSAGE = 'requires a Non-Permitted Laboratory Test Request Approval Form for {STATE} customers. Please attach your NPL form to your order, otherwise we will not be able to process your order.';
 public static readonly UNDEFINED = 'Undefined';
 public static readonly LOWERCASE_UNDEFINED = 'undefined';
}

export class Routes {
  public static readonly PRIVACY_POLICY_ROUTE = 'privacy-policy';
  public static readonly TERMS_OF_USE_ROUTE = 'terms-of-use';
  public static readonly EMAIL_NOTICATIONS_ROUTE = '/email-notification';
  public static readonly CREATE_ORDER_ROUTE = 'create-order';
  public static readonly PLACE_ORDER_ROUTE = 'order/create-order';
  public static readonly ORDER_FORM = 'order/order-form';
  public static readonly PACKAGE_ROUTE = 'order/manage-packages/add-order';
  public static readonly MANAGE_PACKAGE = 'order/manage-packages';
  public static readonly CREATE_BULK_ORDERS = 'order/create-bulk-order';
  public static readonly MFA_VERIFICATION_ROUTE = 'account/mfa-authentication';
}

export class Condition {
  public static PARAMETER_LENGTH = 'length';
  public static PARAMETER_UPPERCASE = 'upperCase';
  public static PARAMETER_LOWERCASE = 'lowerCase';
  public static PARAMETER_NUMBER = 'number';
  public static PARAMETER_SPECIALCHAR = 'specialChar';
}

export class CollectionEnumMaster {
  public static Onsite = 'Onsite';
  public static Home = 'At-Home';
}

export class BillingTypes {
  public static readonly CLIENT_BILL = 'ClientBill';
  public static readonly SELF_PAY = 'SelfPay';
  public static readonly SELFPAY_OR_INSURANCE = 'SelfPayOrInsurance';
  public static readonly INSURANCE = 'Insurance';
}

export class ErrorMessages {
  public static EXPORT_FAILURE = 'Failed to export data.';
}

export class GenderRestrictions {
  public static NO_RESTRICTIONS = 'NoRestrictions';
}

export class Status {
  public static readonly ACTIVE = 'Active';
  public static readonly INACTIVE = 'Inactive';
}

export class PackageStatus {
  public static readonly CURRENT = 'Current';
}

export class TestType {
  public static readonly TEST = 'Test';
  public static readonly PANEL = 'Panel';
}

export class PkgOrRequisitionSearchCriteria {
  public static readonly PKG = 'PKG';
  public static readonly PKGHYPHEN = 'PKG-';
  public static readonly DTP = 'DPT';
  public static readonly DPTHTPHEN = 'DPT-';
  public static readonly RDPT = 'R-DPT';
  public static readonly RDPTHYPHEN = 'R-DPT-';
  public static readonly CTX = 'CTX';
  public static readonly CTXHTPHEN = 'CTX-';
  public static readonly RCTX = 'R-CTX';
  public static readonly RCTXHYPHEN = 'R-CTX-';
}

export class HotKeysHelper {

  public static INPUT = 'input';
  public static MAT_SELECT = 'mat-select';
  public static MAT_ROW = 'mat-row';
  public static DROPDOWN = 'DropDown';
  // public static MAT_TABLE =
  public static MANAGE_PACKAGE_URL = 'manage-packages';
  public static readonly LOWER_CASE_I = 'i';
  public static readonly UPPER_CASE_I = 'I';
  public static readonly LOWER_CASE_C = 'c';
  public static readonly UPPER_CASE_C = 'C';
  public static readonly LOWER_CASE_D = 'd';
  public static readonly UPPER_CASE_D = 'D';
  public static readonly LOWER_CASE_O = 'o';
  public static readonly UPPER_CASE_O = 'O';
  public static readonly LOWER_CASE_P = 'p';
  public static readonly UPPER_CASE_P = 'P';
  public static readonly LOWER_CASE_T = 't';
  public static readonly UPPER_CASE_T = 'T';
  public static readonly LOWER_CASE_Y = 'y';
  public static readonly UPPER_CASE_Y = 'Y';
  public static readonly LOWER_CASE_R = 'r';
  public static readonly UPPER_CASE_R = 'R';
  public static readonly LOWER_CASE_B = 'b';
  public static readonly UPPER_CASE_B = 'B';
  public static readonly LOWER_CASE_K = 'k';
  public static readonly UPPER_CASE_K = 'K';
  public static readonly LOWER_CASE_S = 's';
  public static readonly UPPER_CASE_S = 'S';
  public static readonly LOWER_CASE_X = 'x';
  public static readonly UPPER_CASE_X = 'X';
  public static readonly LOWER_CASE_N = 'n';
  public static readonly UPPER_CASE_N = 'N';
  public static readonly LOWER_CASE_U = 'u';
  public static readonly UPPER_CASE_U = 'U';

  public static readonly CLIENT_IDENTIFIER_HELPTEXT = '(Alt+C)';
  public static readonly PATIENT_DONOR_INFORMATION_HELPTEXT = '(Alt+D)';
  public static readonly ORDER_INFORMATION_HELPTEXT = '(Alt+O)';
  public static readonly PROFILES_HELPTEXT = '(Alt+P)';
  public static readonly TESTS_SINGLE_TEST_HELPTEXT = '(Alt+T)';
  public static readonly COPY_TO_ACCOUNT_HELPTEXT = '(Alt+Y)';
  public static readonly REFLEX_RULES_HELPTEXT = '(Alt+R)';
  public static readonly BILLING_RULES_HELPTEXT = '(Alt+B)';
  public static readonly SPECIMEN_INFORMATION_HELPTEXT = '(Alt+K)';
  public static readonly ADD_PACKAGE_HELP_TEXT = '(Alt+N)';
}

export class DrawChoice {
  public static ScheduledInClinic = 'Scheduled in clinic';
  public static TransplantGenomicsToScheduleDraw = 'Transplant Genomics to schedule draw';
  public static readonly ThirdPartyDraw = 'Third party draw - Kit request';
}

export class TestingReason {
  public static readonly ForCause = 'ForCause';
  public static Surveillance = 'Surveillance'
}

export class TestStatus {
  public static readonly Cancelled = 'Cancelled';
  public static readonly TNP = 'TNP';
}

export class UserActivityLog {
  public static readonly InitialMessageBeforeSearch ='Please perform a search to load User activity logs.';
  public static readonly ActivityDetails ='activityDetail';
  public static readonly ActivityDetailsFilterMessage = '\'Activity Details\' will show up once you apply one of the filters above.';
}
export class CountryCodes {
  public static readonly USA = 'USA';
}
